import { useState, useRef } from 'react';
import { useClickOutside } from './useClickOutside';

/**
 * Hook pour gérer l'état d'un dropdown
 * Gère l'ouverture/fermeture et le clic en dehors automatiquement
 */
export const useDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const toggle = () => setIsOpen(prev => !prev);
  const close = () => setIsOpen(false);
  const open = () => setIsOpen(true);

  useClickOutside(ref, close, isOpen);

  return { isOpen, toggle, close, open, ref };
};

